module.exports = __webpack_public_path__ + "static/hiv-aids-4cc26eef28ac22c7007b2feebf7c7e70.png";